// Dependencies
import styled from 'styled-components';

const BlogPostFeaturedImageStyles = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;

  @media (min-width: 768px) {
    .featured-img {
      ${(props) =>
        props?.fit === 'desktop' &&
        `
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
      `}
    }
  }
`;

export default BlogPostFeaturedImageStyles;
